import axios from 'axios';
import { IMessage, IMessageCollection, IMessageCollectionParams, IMessageSendPayload } from 'app/models/message.models';

const basePath = '/conversations';

export const messageService = {
  getMessages: (params: IMessageCollectionParams): Promise<IMessageCollection> => axios.get(`${basePath}/items`, { params }),
  sendMessage: (payload: IMessageSendPayload): Promise<IMessage> => axios.post(`${basePath}/message`, payload),
};
